import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import style from './cta.sass'

class Cta extends Component {
  render() {
    return(
      <section styleName='wrapper'>
        <div className='landing-container'>
          <h3><span>10,000+</span> strategies built and tested on Algoriz</h3>
          <p>
            Find out how your insights and instincts combined with the most innovative AI can build market beating strategies.
          </p>
          <Link to='/pricing'>Get Started for Free</Link>
        </div>
      </section>
    )
  }
}

export default Cta
